import { useState, useEffect } from 'react';

export const useErrorMessageHeight = (
  target: React.MutableRefObject<HTMLElement>,
  condition: boolean,
) => {
  const [errorMessageHeight, setErrorMessageHeight] = useState<number>(0);

  useEffect(() => {
    if (condition) {
      setErrorMessageHeight(target.current?.clientHeight ?? 0);
      return;
    }
    setErrorMessageHeight(0);
  }, [condition, target]);

  return errorMessageHeight;
};
